import LocalStorageHelper from "helpers/LocalStorageHelper";
import { NewApplication } from "pages";
import ApplicationPage from "pages/Application";
import { ApplicationPageTabs } from "pages/Application/types";
import { NewApplicationSuccess } from "pages/NewApplication/outcomes/success";
import { ApplicationFormData } from "pages/NewApplication/steps/types";
import { Navigate, Route, Routes } from "react-router-dom";

export default function ApplicationRoutes(): JSX.Element {
	const [savedApplicationData, setSavedApplicationData] =
		LocalStorageHelper.useLocalStorageState<ApplicationFormData>(
			LocalStorageHelper.applicationDraftKey
		);

	return (
		<Routes>
			<Route
				path="/sucesso"
				element={
					<NewApplicationSuccess savedApplicationData={savedApplicationData} />
				}
			/>
			<Route
				path="/:applicationId"
				element={<Navigate to={`./${ApplicationPageTabs.DETAILS}`} />}
			/>
			<Route
				path="/:applicationId/:selectedTab"
				element={<ApplicationPage />}
			/>
			<Route
				path="/"
				element={
					<NewApplication
						savedApplicationData={savedApplicationData}
						setSavedApplicationData={setSavedApplicationData}
					/>
				}
			/>
		</Routes>
	);
}
